import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=c8b8e0f4&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=c8b8e0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b8e0f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8b8e0f4')) {
      api.createRecord('c8b8e0f4', component.options)
    } else {
      api.reload('c8b8e0f4', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=c8b8e0f4&scoped=true&", function () {
      api.rerender('c8b8e0f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AoMijUV698hS/JS/comp/DateRangeExt.vue"
export default component.exports